import type { MarketplaceConfig } from '../../queries/marketplace';

export type CryptoCashierConfig =
  | { provider: 'moralis'; requiresPaymentMethod: true; depositEnabled: boolean; withdrawalEnabled: boolean }
  | {
      provider: 'zero_x_processing';
      requiresPaymentMethod: false;
      depositEnabled: boolean;
      withdrawalEnabled: boolean;
    };

type CryptoMarketplaceConfig = Pick<
  MarketplaceConfig['marketplaceConfig'],
  'cryptoProvider' | 'moralis' | 'zeroXProcessing'
>;

export const resolveCryptoCashierConfig = (config?: CryptoMarketplaceConfig): CryptoCashierConfig => {
  if (config?.cryptoProvider === 'zero_x_processing') {
    return {
      provider: 'zero_x_processing',
      requiresPaymentMethod: false,
      depositEnabled: config.zeroXProcessing?.enabled === true && config.zeroXProcessing.depositEnabled === true,
      withdrawalEnabled: config.zeroXProcessing?.enabled === true && config.zeroXProcessing.withdrawalEnabled === true,
    };
  }
  return {
    provider: 'moralis',
    requiresPaymentMethod: true,
    depositEnabled: config?.moralis?.depositEnabled !== false,
    withdrawalEnabled: config?.moralis?.withdrawalEnabled !== false,
  };
};
